export enum ActionConstant {
	GET_REF_LIST = 'FILE://PROJECT_MANAGEMENT/GET_REF_LIST',
	CLEAR_REF_LIST = 'FILE://PROJECT_MANAGEMENT/CLEAR_REF_LIST',
	GET_STATUS = 'FILE://PROJECT_MANAGEMENT/GET_STATUS',
	CLEAR_STATUS = 'FILE://PROJECT_MANAGEMENT/CLEAR_STATUS',
}

export interface RefLists {
	type: ActionConstant.GET_REF_LIST;
	count: number;
	rows: any[];
}

export interface ClearRefDataType {
	type: ActionConstant.CLEAR_REF_LIST;
}
export interface ClearStatusType {
	type: ActionConstant.CLEAR_STATUS;
}

export interface GetRefListType {
	type: ActionConstant.GET_REF_LIST;
	data: RefLists;
}
export interface GetStatusType {
	type: ActionConstant.GET_STATUS;
	status: number;
}

export type ActionType = GetStatusType | ClearStatusType | GetRefListType | ClearRefDataType;
// State Types

export interface InitialState {
	initialList: boolean;
	reflist: any[];
	statusCode: number;
	refcount: number;
	reffetching: boolean;
}
